export type ColorScheme = 'light' | 'dark';

export type BoardPrefs = {
  colorScheme: ColorScheme;
};

const KEY = 'mm-board-prefs';
const DEFAULT: BoardPrefs = { colorScheme: 'light' };

export function loadPrefs(): BoardPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT;
    const parsed = JSON.parse(raw) as Partial<BoardPrefs>;
    const colorScheme: ColorScheme =
      parsed.colorScheme === 'light' || parsed.colorScheme === 'dark'
        ? parsed.colorScheme
        : DEFAULT.colorScheme;
    return { colorScheme };
  } catch {
    return DEFAULT;
  }
}

export function savePrefs(p: BoardPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // storage full / disabled
  }
}

export function nextColorScheme(current: ColorScheme): ColorScheme {
  return current === 'light' ? 'dark' : 'light';
}

export function colorSchemeLabel(c: ColorScheme): string {
  return c === 'light' ? 'Светлая' : 'Тёмная';
}

export function applyColorScheme(c: ColorScheme): void {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.toggle('dark', c === 'dark');
    document.documentElement.style.colorScheme = c;
  }
}
